import { useState } from "react";
import { Users, BookOpen, Building2, GraduationCap, Globe, Plus, Briefcase, Trophy, Bell, BellOff, ChevronDown, ChevronUp } from "lucide-react";








const sections = [
{ id: "all", label: "All", icon: Globe },
{ id: "leaderboard", label: "Leaderboard", icon: Trophy },
{ id: "people", label: "People", icon: Users },
{ id: "classes", label: "Classes", icon: BookOpen },
{ id: "clubs", label: "Clubs", icon: Users },
{ id: "companies", label: "Companies", icon: Briefcase },
{ id: "universities", label: "Universities", icon: GraduationCap },
{ id: "groups", label: "Groups", icon: Building2 }];


const typeIcons = {
  class: BookOpen,
  club: Users,
  company: Briefcase,
  university: GraduationCap,
  group: Building2
};

const myCommunity = [
{ id: 1, name: "CS201 — Data Structures", type: "class", members: 45, newPosts: 3, notificationsOn: true },
{ id: 2, name: "MATH301 — Linear Algebra", type: "class", members: 32, newPosts: 0, notificationsOn: true },
{ id: 3, name: "CHEM101 — General Chemistry", type: "class", members: 58, newPosts: 1, notificationsOn: false },
{ id: 4, name: "Robotics Club", type: "club", members: 24, newPosts: 5, notificationsOn: true },
{ id: 5, name: "TechCorp Azerbaijan", type: "company", members: 120, newPosts: 2, notificationsOn: false },
{ id: 6, name: "ADA University", type: "university", members: 3200, newPosts: 8, notificationsOn: true },
{ id: 7, name: "AI Research Group", type: "group", members: 18, newPosts: 0, notificationsOn: true }];


const CommunityLeftSidebar = ({ activeFilter, onFilterChange, onCreateClass }) => {
  const showCreate = activeFilter === "classes" || activeFilter === "clubs" || activeFilter === "groups";
  const createLabel = activeFilter === "classes" ? "Create Class" : activeFilter === "clubs" ? "Create Club" : "Create Group";
  const [expanded, setExpanded] = useState(true);
  const [notifications, setNotifications] = useState(
    Object.fromEntries(myCommunity.map((c) => [c.id, c.notificationsOn]))
  );

  const toggleNotification = (id, e) => {
    e.stopPropagation();
    setNotifications((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="space-y-4">
      <div className="stat-card !p-4">
        <h3 className="text-sm font-display font-bold text-foreground mb-3">Browse</h3>
        <div className="space-y-1">
          {sections.map((s) =>
          <button
            key={s.id}
            onClick={() => onFilterChange(s.id)}
            className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm font-medium transition-colors ${
            activeFilter === s.id ?
            "bg-secondary/15 text-secondary" :
            "text-muted-foreground hover:bg-muted hover:text-foreground"}`
            }>
            
              <s.icon className="w-4 h-4" />
              {s.label}
            </button>
          )}
        </div>
      </div>

      {/* My Community */}
      <div className="stat-card !p-4">
        <button
          onClick={() => setExpanded(!expanded)}
          className="w-full flex items-center justify-between mb-2">
          
          <h3 className="text-xs font-display font-bold uppercase tracking-wider text-muted-foreground">My Community</h3>
          {expanded ? <ChevronUp className="w-3.5 h-3.5 text-muted-foreground" /> : <ChevronDown className="w-3.5 h-3.5 text-muted-foreground" />}
        </button>
        {expanded &&
        <div className="space-y-0.5">
            {myCommunity.map((item) => {
            const Icon = typeIcons[item.type] || Globe;
            return (
              <div key={item.id} className="group w-full flex items-center gap-2 px-3 py-2 rounded-xl text-xs font-medium text-muted-foreground hover:bg-muted hover:text-foreground transition-colors text-left">
                  <Icon className="w-3.5 h-3.5 flex-shrink-0" />
                  <span className="truncate flex-1">{item.name}</span>
                  {item.newPosts > 0 &&
                <span className="w-4 h-4 rounded-full bg-secondary text-secondary-foreground text-[9px] font-bold flex items-center justify-center flex-shrink-0">
                      {item.newPosts}
                    </span>
                }
                  <button
                  onClick={(e) => toggleNotification(item.id, e)}
                  className="opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0"
                  title={notifications[item.id] ? "Mute notifications" : "Enable notifications"}>
                  
                    {notifications[item.id] ?
                  <Bell className="w-3 h-3 text-secondary" /> :

                  <BellOff className="w-3 h-3 text-muted-foreground/50" />
                  }
                  </button>
                </div>);

          })}
          </div>
        }
      </div>

      {showCreate &&
      <button onClick={onCreateClass} className="w-full stat-card !p-3 flex items-center gap-2 text-sm font-semibold text-secondary hover:bg-secondary/5 transition-colors">
          <Plus className="w-4 h-4" />
          {createLabel}
        </button>
      }

    </div>);

};

export default CommunityLeftSidebar;